<template>
  <div id="memed-embed"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MemedEmbed',
  props: {
    token: {
      type: String,
      required: true
    },
    instanciaAplicacao: {
      type: Number,
      required: true
    },
    paciente: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loadedSdk: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo'])
  },
  async mounted () {
    await this.init()
  },
  methods: {
    async init () {
      if (window.MdSinapsePrescricao && window.MdHub) {
        return
      }

      this.setLoading(true)
      const loaded = await this.loadSdk()
      const paciente = this.paciente
      const loading = this.setLoading
      if (loaded) {
        window.MdSinapsePrescricao.event.add('core:moduleInit', async (module) => {
          if (module.name === 'plataforma.prescricao') {
            if (paciente && paciente.id && paciente.nome) {
              const data = {
                idExterno: paciente.id,
                nome: paciente.nome,
                telefone: paciente.telefone,
                cpf: paciente.cpf,
                data_nascimento: paciente.dataNascimento

              }
              if (!paciente.cpf) {
                delete data.cpf
                data.withoutCpf = true
              }

              await window.MdHub.command.send('plataforma.prescricao', 'setPaciente', data)
            }

            await window.MdHub.command.send('plataforma.prescricao', 'setFeatureToggle', {
              // Habilita o envio de SMS automático para o paciente no momento em que a receita é gerada
              alwaysSendSMS: false,
              // Desativa a opção de excluir um paciente
              deletePatient: false,
              // Esconde o histórico de prescrições
              historyPrescription: false,
              // Esconde o botão "Nova Prescrição"
              newPrescription: true,
              // Esconde o botão "Opções Receituário"
              optionsPrescription: true,
              // Desabilita a opção de remover/trocar o paciente
              removePatient: false,
              // Esconde o formulário de edição do paciente
              editPatient: false,
              // Desabilita a opção para definir alergias para o paciente
              setPatientAllergy: true,
              // Desabilita a aba "Exames" do Autocomplete de medicamentos
              autocompleteExams: true,
              // Desabilita a aba "Industrializados" do Autocomplete de medicamentos
              autocompleteIndustrialized: true,
              // Desabilita a aba "Manipulados" do Autocomplete de medicamentos
              autocompleteManipulated: true,
              // Desabilita a aba "Composições" do Autocomplete de medicamentos
              autocompleteCompositions: true,
              // Desabilita a aba "Periféricos" do Autocomplete de medicamentos
              autocompletePeripherals: true,
              // Esconde o botão "Copiar para Prontuário" (que copia o conteúdo da prescrição para o clipboard)
              copyMedicalRecords: true,
              // Esconde o botão de fechar da prescrição
              buttonClose: false,
              // Habilita opção Nova Fórmula Manipulada no menu
              newFormula: true,
              // Removendo o componente Onboarding da tela
              guidesOnboarding: false
            })
            loading(false)

            window.MdHub.module.show('plataforma.prescricao')
            window.MdHub.event.add('prescricaoImpressa', (prescriptionData) => {
              this.$emit('newPrescription', prescriptionData)
            })
            // document.getElementById('memed-embed').setAttribute('style', 'height:100vh')
          }
        })
      }
    },
    async loadSdk () {
      if (window.MdSinapsePrescricao && window.MdHub) {
        return true
      }

      const token = this.token
      const instanciaAplicacao = this.instanciaAplicacao
      const primaryColor = this.estilo.aplicacao.corPrimariaAplicacao
      return new Promise((resolve, reject) => {
        let urlMemed = 'https://partners.memed.com.br/integration.js'
        if (instanciaAplicacao === 1) {
          urlMemed = 'https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js'
        }

        let script = document.createElement('script')
        script.onload = () => {
          resolve(true)
        }
        script.async = true
        script.src = urlMemed
        script.setAttribute('data-token', token)
        script.setAttribute('data-color', primaryColor)
        script.setAttribute('data-container', 'memed-embed')
        document.body.appendChild(script)
      })
    },
    setLoading (isLoading) {
      this.$emit('isLoading', isLoading)
    }
  }
}
</script>

<style scoped>
  #memed-embed {
    height: calc(100% - 40px) !important;
  }
</style>
